import find from "./find";
import update from "./update";
import changeLang from "./changeLang";
import setOneSignalPlayerId from "./setOneSignalPlayerId";
import checkProgress from "./checkProgress";
import uploadPhoto from "./uploadPhoto";
import editAccount from "./editAccount";
import fetchAccount from "./fetchAccount";
import replayPayment from "./replayPayment";
import syncDevices from "./syncDevices";
import deleteSubUsers from "./deleteSubUsers";
import addAirbnbAccount from "./addAirbnbAccount";
import verifyAirlockValidation from "./verifyAirlockValidation";
import getFrictionView from "./getFrictionView";
import sendSmsV2 from "./sendsmsV2";
import airlockValidationV2 from "./airlockValidationV2";
import deleteAirbnbAccount from "./deleteAirbnbAccount";
import getAccountRights from "./getAccountRights";
import getUserWithStatuses from "./getUserWithStatuses";
import fetchEvents from "./fetchEvents";
import deleteTeamMembers from "./deleteTeamMembers";
import updateTeamMembers from "./updateTeamMembers";
import confirmUser from "./confirmUser";
import changePassword from "./changePassword";
import verifyAirbnbAccountViaPhoneOrEmail from "./verifyAirbnbAccountViaPhoneOrEmail";
import checkAirbnbVerificationCode from "./checkAirbnbVerificationCode";
import getAirbnbAccounts from "./getAirbnbAccounts";
import syncSuperCheckin from "./syncSuperCheckin";
import getSuperCheckinLocks from "./getSuperCheckinLocks";
import getAccountLockTypes from "./getAccountLockTypes";
import editAirbnbAccountPwd from "./editAirbnbAccountPwd";
import validateFirstStepUserData from "./validateFirstStepUserData";
import fetchUserAccount from "./fetchUserAccount";
import deleteAvatar from "./deleteAvatar";
import createNewAirbnbAccount from "./createNewAirbnbAccount";
import getStripeKey from "./getStripeKey";
import subscribePrelaunchUser from "./subscribePrelaunchUser";
import syncIgloohome from "./syncIgloohome";
import loginIgloohomeV2 from "./loginIgloohomeV2";
import refreshIgloohomeV2 from "./refreshIgloohomeV2";
import deleteIgloohome from "./deleteIgloohome";
import deleteIgloohomeV2 from "./deleteIgloohomeV2";
import updateOnboardingStep from "./updateOnboardingStep";
import editUserData from "./editUserData";
import deleteSuperCheckinAccount from "./deleteSuperCheckinAccount";
import unlockUser from "./unLockUser";
import confirmAccount from "./confirmAccount";
import deleteNetatmoAccount from "./deleteNetatmoAccount";
import uploadMemberAvatar from "./uploadMemberAvatar";
import getUserRentals from "./getUserRentals";

import disabledBanner from "./disabledBanner";
import getRentalInfo from "./getRentalInfo";
import getConnectedStripePublicKey from "./getConnectedStripePublicKey";
import getConnectedStripePublicKeyForBookingReservation from "./getConnectedStripePublicKeyForBookingReservation";
import syncNukiLocks from "./syncNukiLocks";
import deleteNukiLock from "./deleteNukiLock";
import createPromoCode from "./createPromoCode";
import getPromoCodes from "./getPromoCodes";
import deletePromoCode from "./deletePromoCode";
import updatePromoCode from "./updatePromoCode";
import applyPromoCode from "./applyPromoCode";

export default {
  find,
  update,
  changeLang,
  checkProgress,
  uploadPhoto,
  editAccount,
  changePassword,
  fetchAccount,
  fetchEvents,
  replayPayment,
  syncDevices,
  deleteSubUsers,
  deleteTeamMembers,
  setOneSignalPlayerId,
  addAirbnbAccount,
  verifyAirlockValidation,
  getFrictionView,
  sendSmsV2,
  airlockValidationV2,
  deleteAirbnbAccount,
  getAccountRights,
  getUserWithStatuses,
  updateTeamMembers,
  confirmUser,
  verifyAirbnbAccountViaPhoneOrEmail,
  checkAirbnbVerificationCode,
  getAirbnbAccounts,
  syncSuperCheckin,
  getSuperCheckinLocks,
  getAccountLockTypes,
  editAirbnbAccountPwd,
  validateFirstStepUserData,
  fetchUserAccount,
  deleteAvatar,
  createNewAirbnbAccount,
  getStripeKey,
  subscribePrelaunchUser,
  syncIgloohome,
  deleteIgloohome,
  deleteIgloohomeV2,
  loginIgloohomeV2,
  refreshIgloohomeV2,
  updateOnboardingStep,
  editUserData,
  deleteSuperCheckinAccount,
  unlockUser,
  confirmAccount,
  deleteNetatmoAccount,
  uploadMemberAvatar,
  getUserRentals,
  getRentalInfo,
  getConnectedStripePublicKey,
  getConnectedStripePublicKeyForBookingReservation,
  createPromoCode,
  getPromoCodes,
  deletePromoCode,
  updatePromoCode,
  applyPromoCode,
  syncNukiLocks,
  deleteNukiLock,
  disabledBanner,
};



// WEBPACK FOOTER //
// ./src/app/services/account/index.js